import { createTheme } from "@material-ui/core/styles";

export const theme = createTheme({
    overrides: {
        MuiPaper: {
            rounded: {
                borderRadius: "10px",
            },
        },
        MuiIconButton: {
            root: {
                "&:focus": {
                    outline: "none",
                },
            },
        },
        MuiTypography: {
            root: {
                color: "var(--blue-bell)",
                fontFamily: "Arial",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "14px",
                letterSpacing: "0px",
                display: "inline",
            },
        },
        MuiPickersBasePicker: {
            pickerView: {
                width: "328px",
            },
        },
        MuiPickersDay: {
            root: {
                "&$selected": {
                    backgroundColor: "var(--blue-medium)",
                    outline: "none !important",
                },
                "&$focus": {
                    outline: "none !important",
                },
                width: "40px",
                height: "40px",
            },
            today: {
                fontWeight: "700",
                color: "var(--blue-status)",
                border: "none !important",
            },
            dayOutsideMonth: {
                backgroundColor: "var(--grey-background) !important",
                borderRadius: "unset",
            },
            dayWithMargin: {
                margin: "unset",
            },
        },
        MuiPickersDateRangePickerInput: {
            root: {
                display: "table-cell",
                paddingLeft: "9px",
            },
        },
        MuiPickersDateRangeDay: {
            rangeIntervalDayHighlight: {
                backgroundColor: "var(--blue-bell)",
            },
            day: {},
        },
        MuiPickersCalendar: {
            root: {
                minHeight: "240px",
            },
            weekDayLabel: {
                margin: "unset",
                width: "40px",
                height: "40px",
            },
        },
        MuiDialogActions: {
            root: {
                display: "unset",
            },
        },
    },
});
